<div class="page-body">
  <div *ngIf="!loading && error" class="error-wrapper">
    <div class="contents-container">
      <p class="heading">{{ translations.errorHeading }}</p>
      <p class="info-text">
        {{ translations.errorInfo }}
      </p>

      <div class="button-wrapper">
        <zaver-secondary-button-outlined
          class="error-button"
          [text]="translations.backButton"
          (click)="handleCancellation()"
          [rounded]="true"
          [disabled]="navigationInProgress"
        ></zaver-secondary-button-outlined>
      </div>
    </div>
  </div>

  <div *ngIf="loading && !error">
    <app-spinner [infoText]="translations.loading"></app-spinner>
  </div>

  <div *ngIf="!loading && !error">
    <div class="banner">
      <button type="button" class="back-button" (click)="handleCancellation()">
        <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
        <span>{{
        translations.cancellationButton
      }}</span>
      </button>
    </div>

    <div class="contents-wrapper">
      <div class="contents-container">
        <div class="page-header-container">
          <div class="page-heading">
            {{ translations.firstPageHeader }}
          </div>

          <p class="page-sub-heading">
            {{ translations.firstPageSubHeader }}
          </p>
        </div>

        <div *ngIf="kalpAnswers.occupation">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.occupation }}</div>
            <div>{{ getOccupationOptions(kalpAnswers.occupation) }}</div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.monthlyNetIncome">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.monthlyNetIncome }}</div>
            <div>{{ kalpAnswers.monthlyNetIncome }}{{ currencySymbol }}</div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.nameOfEmployer">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.nameOfEmployer }}</div>
            <div>{{ kalpAnswers.nameOfEmployer }}</div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.martialStatus">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.martialStatus }}</div>
            <div>{{ getMartialStatusOptions(kalpAnswers.martialStatus) }}</div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.typeOfAccommodation">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.typeOfAccommodation }}</div>
            <div>
              {{
                getTypeOfAccommodationOtions(kalpAnswers.typeOfAccommodation)
              }}
            </div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.amountOfChildren">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.amountOfChildren }}</div>
            <div>{{ kalpAnswers.amountOfChildren }}</div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.rentOrFeePerMonth">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.rentOrFeePerMonth }}</div>
            <div>{{ kalpAnswers.rentOrFeePerMonth }}{{ currencySymbol }}</div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.totalMortgage">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.totalMortgage }}</div>
            <div>{{ kalpAnswers.totalMortgage }}{{ currencySymbol }}</div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.mortgagePaymentPerMonth">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.mortgagePaymentPerMonth }}</div>
            <div>
              {{ kalpAnswers.mortgagePaymentPerMonth }}{{ currencySymbol }}
            </div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.totalAmountOfOtherLoans">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.totalAmountOfOtherLoans }}</div>
            <div>
              {{ kalpAnswers.totalAmountOfOtherLoans }}{{ currencySymbol }}
            </div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.monthlyObligationForOtherLoans">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.monthlyObligationForOtherLoans }}</div>
            <div>
              {{ kalpAnswers.monthlyObligationForOtherLoans
              }}{{ currencySymbol }}
            </div>
          </div>
        </div>

        <div *ngIf="kalpAnswers.monthlyLivingExpenses">
          <hr class="details-divider" />
          <div class="details-row">
            <div>{{ translations.monthlyLivingExpenses }}</div>
            <div>
              {{ kalpAnswers.monthlyLivingExpenses }}{{ currencySymbol }}
            </div>
          </div>
          <hr class="details-divider" />
        </div>

        <zaver-primary-button
          class="continue-button"
          [text]="translations.continueButton"
          (click)="handleCtaClick()"
        ></zaver-primary-button>

        <zaver-secondary-button-outlined
          class="update-button"
          [text]="translations.updateButton"
          (click)="handleUpdateClick()"
        ></zaver-secondary-button-outlined>
      </div>
    </div>
  </div>
</div>
